import { useMemo } from 'react';
import { mergeRoutes, MergeRoutesConfig } from '@core/lib/merge-routes';
import { Routes } from '@core/constants/routes';

export const useMergeRoutes = (
  routes: Routes | Routes[],
  config: MergeRoutesConfig
) => {
  return useMemo<string>(() => mergeRoutes(routes, config), [routes]);
};
